export default {"src":"/_next/static/media/steem.6bd28cbc.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};